import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MapPage from './pages/MapPage';
import WxappPage from './pages/WxappPage';
import WeatherMap from './components/WeatherMap';
import OpenSkiMapView from './components/OpenSkiMapView';
import TabControl from './components/TabControl';
import RankingMap from './components/RankingMap';
import NearbyMap from './components/NearbyMap';
import FavoritesMap from './components/FavoritesMap';
import BikeSpeedCalculator from './pages/toolbox/BikeSpeedCalculator';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('ranking');

  useEffect(() => {
    // 设置动态favicon
    const link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = `/favicon.ico?t=${new Date().getTime()}`;
    document.head.appendChild(link);
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'ranking':
        return <RankingMap />;
      case 'nearby':
        return <NearbyMap />;
      case 'weather':
        return <WeatherMap />;
      case 'favorites':
        return <FavoritesMap />;
      default:
        return <RankingMap />;
    }
  };

  return (
    <Router>
      <Routes>
        <Route path="/wxapp" element={<WxappPage />} />
        <Route path="/weather" element={<WeatherMap />} />
        <Route path="/map" element={<OpenSkiMapView />} />
        <Route path="/toolbox/bike-calculator" element={<BikeSpeedCalculator />} />
        <Route path="/" element={
          <div className="app">
            <TabControl activeTab={activeTab} onTabChange={setActiveTab} />
            {renderContent()}
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App; 